// components/CMS/PartnerLogos.js
import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Typography from "aldoo-ra/Typography"
import { url } from "aldoo-ra/CMS/url"

const PartnerLogos = () => {
  return (
    <div className="w-full pb-[60px] lg:pb-[112px] px-4 md:px-[56px] xl:px-[76px]">
      <CMSRender
        contentType="PartnerLogos"
        render={(data) => {
          const content = data[0]
          return (
            <div className="w-full 2xl:max-w-[1182px] mx-auto">
              <Typography 
                component="h2"
                variant="h1"
                className="w-full text-center mb-6 md:mb-12 xl:mb-[125px]"
              >
                {content.name}
              </Typography>

              <div className="w-full max-w-[500px] md:max-w-[800px] lg:max-w-[960px] xl:max-w-[1180px] lg:w-[960px] xl:w-full grid grid-cols-2 md:grid-cols-3 gap-x-[56px] lg:gap-x-[115px] xl:lg:gap-x-[168px] gap-y-[36px] md:gap-y-[50px] lg:gap-y-[76
              px] xl:gap-y-[80px] items-center justify-center px-4 md:px-0 mx-auto">
                {content.logos.map((entry, index) => (
                  <img
                    key={index}
                    src={url(entry)}
                    alt={content.name}
                    className="w-[100%] h-auto col-span-1"
                  />
                ))}
              </div>
            </div>
          )
        }}
      />
    </div>
  )
}

const AldooComponent = {
  id: 'PartnerLogos',
  component: PartnerLogos,
  input: {},
  meta: {
    name: 'Partner Logos',
    description: 'Grid display of partner/client logos',
    category: 'Marketing',
  },
}

export { AldooComponent }
export default PartnerLogos
